const Blank = () => {
    return <></>;
};

export default Blank;
